module.exports = __webpack_public_path__ + "img/innovate10x.e012a337.png";